import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The bit hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a bright cyan + warm-orange robot palette pulled from
 * his painted art, on a cool steel-blue tech sky (his own world). Choosing him recolours the WHOLE kid shell:
 * the brand ramp drives buttons / meters / rings in cyan, the canvas glows cool-to-warm, and the hero stage
 * takes his deep steel-blue dusk lit by his screen-glow. Every brand colour is paired with its own legible
 * foreground.
 */
export const bitTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — cyan. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light text
  // (≈ 7:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #207F99 for coloured shadows.
  '--color-primary': '#207F99',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#18A0C3',
  '--color-primary-deep': '#0E5A70',
  '--color-primary-tint': '#DDF3FA',
  '--color-primary-glow-rgb': '32 127 153',
  '--color-secondary': '#E4EBF1',
  '--color-secondary-fg': '#2B3B47',
  '--color-accent': '#FF9A3D',
  '--color-accent-fg': '#4A2600',
  // CANVAS — a cool cyan wash top-left, a soft warm-orange bloom bottom-right (his cheerful workshop light).
  '--canvas-a': '#E1F4FB',
  '--canvas-b': '#FDECD9',
  // A deep steel-blue tech dusk lit by his cyan screen-glow (white text stays AA over it).
  '--sky-top': '#12283a',
  '--sky-mid': '#1f4a63',
  '--sky-low': '#5ba9c4',
  '--sky-glow': '#ffd6a3',
  '--sky-fg': '#ffffff',
});
